/* Playland — panier : source de vérité unique (resync drawer + compteur après chaque changement) */
(function(){
  function T(k,d){var s=window.plStrings;return (s&&s[k])||d;}
  var toastEl;
  function toast(item){
    if(!toastEl){toastEl=document.createElement('div');toastEl.className='pl-toast';toastEl.innerHTML='<span class="pl-toast__check">✓</span><div class="pl-toast__body"><b></b><span></span></div><button type="button" class="pl-toast__btn"></button>';toastEl.querySelector('.pl-toast__body span').textContent=T('added','Ajouté au panier');toastEl.querySelector('.pl-toast__btn').textContent=T('viewCart','Voir le panier');document.body.appendChild(toastEl);
      toastEl.querySelector('.pl-toast__btn').addEventListener('click',function(){var d=document.querySelector('cart-drawer');toastEl.classList.remove('is-on');if(d&&d.open){resync().then(function(){d.open();});}else location.href=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart';});}
    toastEl.querySelector('b').textContent=item&&item.product_title?item.product_title:T('item','Article');
    toastEl.classList.add('is-on');clearTimeout(toastEl._t);toastEl._t=setTimeout(function(){toastEl.classList.remove('is-on')},4500);
  }
  function money(cents){return '€'+(cents/100).toFixed(2).replace('.',',');}
  /* PUB_SUB_EVENTS est un « const » global de constants.js : il n'existe PAS sur window → toujours tester avec typeof */
  function pubsubReady(){return typeof window.subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined';}
  function fixItems(root){
    (root||document).querySelectorAll('cart-drawer .cart-item').forEach(function(row){
      var rb=row.querySelector('cart-remove-button');
      if(rb&&rb.parentElement!==row){row.appendChild(rb);}
      /* Offre 2+1 : Shopify attache l'étiquette de remise à toutes les lignes éligibles, même celles payées plein tarif → on ne la garde que sur les lignes réellement remisées */
      var disc=row.querySelector('.discounts');
      if(disc&&!row.querySelector('.cart-item__discounted-prices')){disc.remove();}
    });
  }
  /* Ligne « 🎁 2 achetés = 1 offert (−X €) » dans le pied du drawer, calculée depuis /cart.js (remises produit = par ligne, Dawn ne les totalise pas) */
  function drawerDiscounts(cart){
    var d=document.querySelector('cart-drawer .cart-drawer__footer > div');if(!d||!cart)return;
    var old=d.querySelector('.pl-drawer-disc');if(old)old.remove();
    var map={},order=[];
    (cart.items||[]).forEach(function(i){(i.line_level_discount_allocations||[]).forEach(function(a){if(a.amount>0){var t=a.discount_application.title;if(!(t in map)){map[t]=0;order.push(t);}map[t]+=a.amount;}});});
    if(!order.length)return;
    var ul=document.createElement('ul');ul.className='discounts list-unstyled pl-drawer-disc';ul.setAttribute('role','list');
    order.forEach(function(t){var li=document.createElement('li');li.className='discounts__discount discounts__discount--end';li.textContent='🎁 '+t+' (−'+money(map[t])+')';ul.appendChild(li);});
    d.prepend(ul);
  }
  function enhanceDrawer(){
    var d=document.querySelector('cart-drawer');if(!d)return;
    var ctas=d.querySelector('.cart__ctas');
    if(ctas&&!ctas.querySelector('.pl-view-cart')){var a=document.createElement('a');a.href=((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart';a.className='pl-view-cart button pl-btn pl-btn--light';a.textContent=T('viewCart','Voir le panier');ctas.insertBefore(a,ctas.firstChild);}
    var ov=d.querySelector('#CartDrawer-Overlay');if(ov&&!ov.__plBound){ov.__plBound=true;ov.addEventListener('click',function(){d.close();});}
    fixItems(d);
  }
  var isCartPage=/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart(?:\/|$)/i.test(location.pathname);
  function noCache(url){return url+(url.indexOf('?')>-1?'&':'?')+'_pl='+Date.now();}
  function getCart(){return fetch(noCache('/cart.js'),{cache:'no-store'}).then(function(r){return r.json()});}
  function swapScripts(el){el.querySelectorAll('script').forEach(function(s){var n=document.createElement('script');n.textContent=s.textContent;s.replaceWith(n);});}

  /* ==== RESYNC : re-rend drawer + bulle depuis le serveur (jamais de cache) ==== */
  var resyncTimer=null,resyncPromise=null;
  function resync(){
    if(resyncPromise)return resyncPromise;
    resyncPromise=fetch(noCache('/?sections=cart-drawer,cart-icon-bubble'),{cache:'no-store'}).then(function(r){return r.json()}).then(function(sec){
      var d=document.querySelector('cart-drawer');
      if(d&&sec['cart-drawer']){
        var t=document.createElement('div');t.innerHTML=sec['cart-drawer'];
        var srcDrawer=t.querySelector('cart-drawer'),srcInner=t.querySelector('#CartDrawer'),dstInner=d.querySelector('#CartDrawer');
        if(srcDrawer){var wasActive=d.classList.contains('active');d.className=srcDrawer.className;if(wasActive)d.classList.add('active');}
        if(srcInner&&dstInner){dstInner.innerHTML=srcInner.innerHTML;}
        enhanceDrawer();
      }
      var b=document.getElementById('cart-icon-bubble');
      if(b&&sec['cart-icon-bubble']){var t2=document.createElement('div');t2.innerHTML=sec['cart-icon-bubble'];var inner=t2.querySelector('.shopify-section')||t2;b.innerHTML=inner.innerHTML;}
      return getCart();
    }).then(function(cart){syncCartPage(cart);drawerDiscounts(cart);return cart;}).catch(function(){}).finally(function(){resyncPromise=null;});
    return resyncPromise;
  }
  function scheduleResync(){clearTimeout(resyncTimer);resyncTimer=setTimeout(resync,120);}

  /* ==== Page panier ==== */
  function sectionIds(){var ids=[];document.querySelectorAll('main[data-template=cart] > .shopify-section').forEach(function(s){var id=s.id.replace('shopify-section-','');if(id)ids.push(id);});return ids;}
  function syncCartPage(cart){
    if(!isCartPage||!cart)return;
    document.body.classList.toggle('pl-cart-empty',cart.item_count===0);
    var c=document.getElementById('pl-cart-count');if(c)c.textContent='('+cart.item_count+')';
    var ci=document.querySelector('cart-items');if(ci)ci.classList.toggle('is-empty',cart.item_count===0);
    var f=document.getElementById('main-cart-footer');if(f)f.classList.toggle('is-empty',cart.item_count===0);
    var cb=document.getElementById('checkout');if(cb)cb.disabled=cart.item_count===0;
  }
  /* L'API Section Rendering refuse plus de 5 sections par requête (400, rien n'est rendu) → on découpe en paquets de 5 */
  function fetchSections(ids){
    var batches=[];for(var k=0;k<ids.length;k+=5)batches.push(ids.slice(k,k+5));
    return Promise.all(batches.map(function(b){
      return fetch(noCache(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'cart?sections='+b.join(',')),{cache:'no-store'}).then(function(r){return r.ok?r.json():{};}).catch(function(){return {};});
    })).then(function(parts){var out={};parts.forEach(function(p){for(var key in p){if(Object.prototype.hasOwnProperty.call(p,key))out[key]=p[key];}});return out;});
  }
  /* all=false : sections Playland seulement (Dawn vient de re-rendre articles + récap) · all=true : tout */
  function refreshCartPage(all){
    if(!isCartPage)return Promise.resolve();
    var ids=sectionIds().filter(function(id){var el=document.getElementById('shopify-section-'+id);if(!el)return false;if(all)return true;return !el.querySelector('#main-cart-items')&&!el.querySelector('#main-cart-footer');});
    if(!ids.length)return Promise.resolve();
    return fetchSections(ids).then(function(sections){
      ids.forEach(function(id){
        var html=sections[id];var el=document.getElementById('shopify-section-'+id);if(!html||!el)return;
        var t=document.createElement('div');t.innerHTML=html;var inner=t.querySelector('.shopify-section')||t;
        if(el.querySelector('#main-cart-items')||el.querySelector('#main-cart-footer')){
          var srcJs=inner.querySelector('.js-contents'),dstJs=el.querySelector('.js-contents');if(srcJs&&dstJs)dstJs.innerHTML=srcJs.innerHTML;
          var srcRoot=inner.querySelector('#main-cart-footer'),dstRoot=el.querySelector('#main-cart-footer');if(srcRoot&&dstRoot)dstRoot.classList.toggle('is-empty',srcRoot.classList.contains('is-empty'));
        }else{el.innerHTML=inner.innerHTML;swapScripts(el);}
      });
    }).catch(function(){});
  }

  /* ==== Hooks Dawn ==== */
  customElements.whenDefined('cart-drawer').then(function(){
    var C=customElements.get('cart-drawer'),P=C.prototype;
    var render=P.renderContents,open=P.open;
    P.renderContents=function(r){
      this.__plSilent=true;var self=this;
      try{render.call(this,r);}catch(e){}
      setTimeout(function(){self.__plSilent=false;},150);
      toast(r);
      resync();
    };
    P.open=function(t){if(this.__plSilent){this.__plSilent=false;return;}var self=this;open.call(this,t);};
    enhanceDrawer();
    var d=document.querySelector('cart-drawer');
    if(d){new MutationObserver(function(){fixItems(d);var ctas=d.querySelector('.cart__ctas');if(ctas&&!ctas.querySelector('.pl-view-cart'))enhanceDrawer();}).observe(d,{childList:true,subtree:true});}
  });
  /* Ouverture du drawer via le bouton header : toujours à jour */
  document.addEventListener('click',function(e){var a=e.target.closest('#cart-icon-bubble');if(!a)return;var d=document.querySelector('cart-drawer');if(!d)return;scheduleResync();},true);

  document.addEventListener('DOMContentLoaded',function(){
    enhanceDrawer();fixItems(document);
    getCart().then(function(cart){syncCartPage(cart);drawerDiscounts(cart);}).catch(function(){});
    /* Messages d'erreur panier Dawn en français */
    if(window.cartStrings){window.cartStrings.error=T('cartError','Oups, un souci est survenu. Réessaie dans un instant.');window.cartStrings.quantityError=T('qtyError','Stock limité : tu peux en prendre [quantity] maximum.');}
    function hook(){
      if(!pubsubReady())return false;
      subscribe(PUB_SUB_EVENTS.cartUpdate,function(ev){
        if(ev&&ev.source==='playland-resync')return;
        scheduleResync();
        /* Changement de quantité Dawn (source cart-items) : articles + récap déjà re-rendus → on complète le reste. Sinon (cadeau, upsell…) : on re-rend tout. */
        if(isCartPage){var all=!(ev&&ev.source==='cart-items');setTimeout(function(){refreshCartPage(all);},150);}
      });
      return true;
    }
    if(!hook()){var tries=0;var iv=setInterval(function(){if(hook()||++tries>20)clearInterval(iv);},250);}
  });

  /* ==== Ajout AJAX pour les formulaires Playland (cartes, upsell) ==== */
  document.addEventListener('submit',function(e){
    var f=e.target;if(!f.matches('form[action*="/cart/add"]'))return;
    if(f.closest('product-form'))return;
    e.preventDefault();
    var fd=new FormData(f);var btn=f.querySelector('[type=submit]');if(btn){btn.disabled=true;}
    fetch('/cart/add.js',{method:'POST',body:fd,headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}}).then(function(r){return r.json()}).then(function(res){
      if(res.status){toast({product_title:res.description||T('retry','Oups, réessaie')});return;}
      toast(res);
      var p=resync();
      if(isCartPage){p.then(function(){return refreshCartPage(true);}).then(function(){var it=f.closest('.pl-upsell__item');if(it)it.remove();return getCart();}).then(syncCartPage);}
    }).catch(function(){toast({product_title:T('retry','Oups, réessaie')});}).finally(function(){if(btn)btn.disabled=false;});
  });

  /* Exposé pour les sections Playland (emballage cadeau…) */
  window.PlaylandCart={refresh:function(){scheduleResync();return refreshCartPage(true);},pubsubReady:pubsubReady};
})();